import { getListEventWonBid, updateFirstView, updateFirstViewBidding } from '@/apis/event-won-bid';
import { EVENT_WON_BID } from '../mutation-types';

export const state = {
  eventWonBid: [],
};

export const getters = {
  getEventWonBid: (state) => state.eventWonBid,
};

export const mutations = {
  [EVENT_WON_BID.GET_EVENT_WON_BID_LIST](state, data) {
    if (!data.error) {
      state.eventWonBid = data;
    }
  },
};

export const actions = {
  async actGetEventWonBid({ commit }, payload) {
    const res = await getListEventWonBid(payload);
    commit(EVENT_WON_BID.GET_EVENT_WON_BID_LIST, res);
    return res;
  },

  async actUpdateFirstView(_, payload) {
    const res = await updateFirstView(payload);
    if (res.error) {
      return {
        error: true,
        messages: res?.error?.response?.data?.errors,
      };
    }

    return { error: false };
  },

  async actUpdateFirstViewBidding(_, payload) {
    const res = await updateFirstViewBidding(payload);
    if (res.error) {
      return {
        error: true,
        messages: res?.error?.response?.data?.errors,
      };
    }

    return { error: false };
  },

};
